/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration (C) Copyright IBM Corp. 2015, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define('collaboration/messaging/utils/CustomStatus',[], function () {
	return {
		/**
   * 562 Access Token Invalid
   */
		TOKEN_INVALID: 562,

		/**
   * 563 Provider Service Failure
   */
		SERVICE_ERROR: 563,

		/**
   * 564 Application is not authorized to call this API
   */
		API_NOT_AUTHORIZED: 564,

		/**
   * 565 Failed to get provider configuration
   */
		PROVIDER_CONFIG_ERROR: 565,

		/**
   * 404 Service not found
   */
		NOT_FOUND_ERROR: 404
	};
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

